<template>
  <v-card @click="openLink" flat :color="backgroundColor">
    <v-img class="white--text align-end" :src="imgSrc" height="200px" :gradient="gradient">
      <v-card-subtitle class="text-h5 text-wrap word-break-advertisment-title" v-html="subtitle" />
    </v-img>

    <v-card-title class="text-h4 word-break-advertisment-title">{{ title }}</v-card-title>
    <v-img class="mx-4" :src="logoSrc" height="100px" contain />
    <v-card-text>{{ content }}</v-card-text>
    <v-card-actions class="mx-2">
      <v-btn class="mb-2" block @click="openLink" large :color="buttonColor">{{ btnText }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class AdvertisementCard extends Vue {
  @Prop()
  title!: string;

  @Prop()
  subtitle!: string;

  @Prop()
  content!: string;

  @Prop()
  imgSrc!: string;

  @Prop()
  logoSrc!: string;

  @Prop()
  link!: string;

  @Prop()
  backgroundColor!: string;

  @Prop()
  btnText!: string;

  @Prop()
  buttonColor!: string;

  @Prop({ default: "to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)" })
  gradient!: string;

  openLink() {
    window.open(this.link, "_blank");
  }
}
</script>
<style>
.word-break-advertisment-title {
  word-break: normal;
}
</style>
